// Universal Accordions Fix
// This ensures both product accordions and FAQ accordions work independently

(function() {
  'use strict';
  
  function initAllAccordions() {
    console.log('🎵 Initializing all accordions (delegated)...');

    // Prevent duplicate bindings across files
    if (window.__accordionsDelegated) {
      console.log('↩️ Accordions already delegated; skipping re-bind');
      return;
    }
    window.__accordionsDelegated = true;

    // Single delegated listener handles both product and general accordions
    document.addEventListener('click', handleDocumentClick, true);

    const productAccordions = document.querySelectorAll('.product-overview_acc-head').length;
    const generalAccordions = document.querySelectorAll('.accordion__head').length;

    console.log('✅ Accordions delegated:', productAccordions, 'product +', generalAccordions, 'general');
  }
  
  function handleDocumentClick(e) {
    const productHead = e.target.closest('.product-overview_acc-head');
    if (productHead) {
      e.preventDefault();
      toggleProductAccordionFromHead(productHead);
      // Stop other handlers from double-toggling
      e.stopPropagation();
      e.stopImmediatePropagation();
      return;
    }

    const generalHead = e.target.closest('.accordion__head');
    if (generalHead) {
      e.preventDefault();
      toggleGeneralAccordionFromHead(generalHead);
      // Stop other handlers from double-toggling
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }

  function toggleProductAccordion(e) {
    e.preventDefault();
    toggleProductAccordionFromHead(e.currentTarget);
  }

  function toggleProductAccordionFromHead(head) {
    const accordion = head.closest('.product-overview_accordion');
    if (!accordion) return;
    const body = accordion.querySelector('.product-overview_acc-body');
    if (!body) return;
    const plusIcon = head.querySelector('.plus-icon');
    const minusIcon = head.querySelector('.minus-icon');

    console.log('🔄 Toggling accordion:', head);

    // Check if accordion is currently open
    const isOpen = accordion.classList.contains('active') || (body.style.maxHeight && body.style.maxHeight !== '0px');

    if (isOpen) {
      // Close accordion
      accordion.classList.remove('active');
      body.style.maxHeight = '0px';
      body.style.opacity = '0';

      // Show plus, hide minus (fallback for inline styles)
      if (plusIcon) plusIcon.style.display = 'block';
      if (minusIcon) minusIcon.style.display = 'none';

      console.log('📦 Accordion closed');
    } else {
      // Open accordion
      accordion.classList.add('active');
      body.style.maxHeight = body.scrollHeight + 'px';
      body.style.opacity = '1';

      // Hide plus, show minus (fallback for inline styles)
      if (plusIcon) plusIcon.style.display = 'none';
      if (minusIcon) minusIcon.style.display = 'block';

      console.log('📂 Accordion opened, height:', body.scrollHeight + 'px');
    }
  }
  
  function toggleGeneralAccordion(e) {
    e.preventDefault();
    toggleGeneralAccordionFromHead(e.currentTarget);
  }

  function toggleGeneralAccordionFromHead(head) {
    const accordion = head.closest('.accordion');
    if (!accordion) return;
    const body = accordion.querySelector('.accordion__body');
    if (!body) return;
    const iconWrap = head.querySelector('.accordion__icon-wrap');
    const verLine = iconWrap ? iconWrap.querySelector('.ver') : null;
    const horLine = iconWrap ? iconWrap.querySelector('.hor') : null;

    console.log('🔄 Toggling general accordion:', head);

    // Check if accordion is currently open
    const isOpen = accordion.classList.contains('active') || (body.style.maxHeight && body.style.maxHeight !== '0px');

    if (isOpen) {
      // Close accordion
      accordion.classList.remove('active');
      body.style.maxHeight = '0px';
      body.style.opacity = '0';

      // Show horizontal line (make plus icon)
      if (horLine) horLine.style.display = 'block';

      console.log('📦 General accordion closed');
    } else {
      // Open accordion
      accordion.classList.add('active');
      body.style.maxHeight = body.scrollHeight + 'px';
      body.style.opacity = '1';

      // Hide horizontal line (make minus icon)
      if (horLine) horLine.style.display = 'none';

      console.log('📂 General accordion opened, height:', body.scrollHeight + 'px');
    }
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllAccordions);
  } else {
    initAllAccordions();
  }
  
  // Also initialize after a short delay to catch any dynamically loaded content
  setTimeout(initAllAccordions, 500);
  
  // Make functions available globally for debugging
  window.accordions = {
    init: initAllAccordions,
    toggleProduct: toggleProductAccordionFromHead,
    toggleGeneral: toggleGeneralAccordionFromHead
  };
  
})();
